import { ENTITY } from 'modules/campaigns/config/routes/entity';
import { useSelectedEntityId } from 'modules/campaigns/hooks/useSelectedEntityId';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';

export const useRecommendationsQueryKey = () => {
    const campaignId = useSelectedEntityId(ENTITY.CAMPAIGN);
    const { accountId } = useAccount();
    return [accountId, campaignId, 'recommendations'];
};
